import React, { Component } from 'react';
import Header from './../../Header';
import { Link, Redirect } from "react-router-dom";
import $ from 'jquery';
import CryptoJS from 'crypto-js';
import config from 'react-global-configuration';
import 'react-datepicker/dist/react-datepicker.css';
import Board from 'react-trello'

const CustomCard = props => {
    // Er 71186: Change in status workflow, Added 24: QACompleted-PreProd
    let getStatusClass = (status) => {
        switch (status) {
            case '109':
                return 'er_sym assigned';
            case '110':
                return 'er_sym assigned';
            case '10':
                return 'er_sym assigned';
            case '50':
                return 'er_sym assigned';
            case '55':
                return 'er_sym active';
            case '60':
                return 'er_sym active';
            case '80':
                return 'er_sym resolved';
            case '82':
                return 'er_sym qa';
            case '83':
                return 'er_sym pm_rev';
            case '84':
                return 'er_sym pm_pass';
            case '85':
                return 'er_sym tested';
            case '88':
                return 'er_sym qa';
            case '90':
                return 'er_sym closed';
            case '91':
                return 'er_sym tospec';
            case '92':
                return 'er_sym tospec';
            case '11':
                return 'er_sym active';
            case '13':
                return 'er_sym active';
            case '14':
                return 'er_sym qa';
            case '15':
                return 'er_sym active';
            case '16':
                return 'er_sym resolved';
            case '17':
                return 'er_sym resolved';
            case '18':
                return 'er_sym qa';
            case '19':
                return 'er_sym active';
            case '20':
                return 'er_sym active';
            case '21':
                return 'er_sym assigned';
            case '22':
                return 'er_sym active';
            case '24':
                return 'er_sym resolved';
            case '25':
                return 'qa';
            case '26':
                return 'active';
            case '27':
                return 'resolved';
            case '28':
                return 'qa';
            case '29':
                return 'active';
            case '30':
                return 'resolved';
            default:
                return 'er_sym new';
        }
    }
    return (
        <div>
            <div class="kanban_list">
                <span>
                <h4 class="list_title">
                    <div class="er_color"><span class={getStatusClass(props.status)}></span></div>
                    <div class="er_ids">{props.id.substring(0, props.id.indexOf('_'))}</div>
                    <div class="kanban_er_title">{props.title}</div>
                </h4>
                <div class="User_assign">{props.attachment ? <div class="pro_img"><img src={props.attachment} /></div> : <span class="profile_first_name">{props.emp_start_name}</span>}<span class="user text-inded">{props.owner_name}</span></div>
                <div class="section gry">
                    <div class="wrap pull-left">
                        <span class="text-capitalize">{props.priority}</span>
                    </div>
                    <div class="wrap pull-right">
                        <span>{props.status_name}</span></div>
                </div>
            </span>
            </div>
        </div>
    )
}

class Kanban extends Component {
    constructor() {
        super();
        var has_local_data = localStorage.getItem('encdata') ? 1 : 0;
        var localdata = has_local_data ? this.decrypt(localStorage.getItem('encdata'), 0) : '';
        this.state = {
            status: [],
            kanban_progress_status: [],
            kanban_test_status: [],
            product_line: [],
            userAuthKey: has_local_data ? localdata.user_key : '',
            apiUrl: this.decryptconfigdata('apiUrl'),
            userId: has_local_data ? localdata.user_id : '',
            loading: 1,
            boardData: {
                lanes: []
            },
            startdate: '',
            search: '',
            kanban_product_line_name: '',
            kanban_owner_name: '',
            status_name: '',
            card_id: '',
            message: '',
            fields: {},
            errors: {},
            item_count: '',
            recently_visited: [],
            recentlyview: localStorage.getItem('recentlyview') ? localStorage.getItem('recentlyview').split(',') : [],
            kanban_status: '',
            workflow: [],
            owners: []
        };
        this.searchChange = this.searchChange.bind(this);
        this.onChange = this.onChange.bind(this);
        this.onStatusChange = this.onStatusChange.bind(this);
    }

    decryptconfigdata(configkey) {
        var key = CryptoJS.enc.Hex.parse(config.get('enc_key'));
        var iv = CryptoJS.enc.Hex.parse(config.get('enc_iv'));
        var bytes = CryptoJS.AES.decrypt(config.get(configkey), key, {
            iv
        });
        var plaintext = bytes.toString(CryptoJS.enc.Utf8);
        return plaintext;
    }

    decrypt(findresponse, flg) {
        var key = CryptoJS.enc.Hex.parse(config.get('enc_key'));
        var iv = CryptoJS.enc.Hex.parse(config.get('enc_iv'));
        var res = flg ? findresponse.encdata : findresponse;
        var bytes = CryptoJS.AES.decrypt(res, key, {
            iv
        });
        var plaintext = bytes.toString(CryptoJS.enc.Utf8);
        return JSON.parse(plaintext);
    }

    rawjsonparse(findresponse, flg) {
        return findresponse;
    }

    handleValidation() {
        let fields = this.state.fields;
        let errors = {};
        let formIsValid = true;
//        if (!fields["status_name"]) {
//            formIsValid = false;
//            errors["status_name"] = "This field is required.";
//        }

        this.setState({ errors: errors });
        return formIsValid;
    }

    searchChange(event) {
        var obj = this;
        this.setState({ search: event.target.value, activePage: 1 });
        //Delaying the function execute
        if (this.timer) {
            window.clearTimeout(this.timer);
        }
        this.timer = window.setTimeout(function () {
            //Execute the function code here...
            obj.ListER();
        }, 500);
    }

    onChange(event) {
        var obj = this;
        this.setState({ [event.target.name]: event.target.value });
        localStorage.setItem([event.target.name], event.target.value);
        this.timer = window.setTimeout(function () {
            //Execute the function code here...
            obj.ListER();
        }, 500);
    }

    onStatusChange(event) {
        let fields = this.state.fields;
        this.setState({ [event.target.name]: event.target.value });
        fields[event.target.name] = event.target.value;
    }

    onCardClick(cardId, metadata, laneId) {
        var card = cardId.indexOf('_');
        cardId = cardId.substring(0, card);
        window.open('/viewEr/' + `${cardId}`, '_blank');
    }

    handleDragEnd(cardId, sourceLaneId, targetLaneId, position) {
        var card = cardId.indexOf('_');
        var card = cardId.substring(0, card);
        var status = cardId.substring(cardId.lastIndexOf("_") + 1);

        if (targetLaneId == 'backloglane' && sourceLaneId != targetLaneId) { // When dragged to Backlog Lane
            if (status == 55) { // When status is Active, change to Assigned and Flagged On
            const fd = new FormData;
            fd.append('status', 50);
                fetch(this.state.apiUrl + '/ErRest/ChangeStatusFromKanban/id/' + card + '/userAuthKey/' + this.state.userAuthKey + '/userId/' + this.state.userId, {
                method: 'POST',
                dataType: 'json',
                body: fd,
            })
                .then((Response) => Response.json())
                .then((findresponse) => {
                    findresponse = this.rawjsonparse(findresponse, 1);
                    if (findresponse.code == 200) {
                        this.setState({ message: findresponse.msg }, function () {
                            this.ListER();
                        });
                    } else {
                        this.setState({ message: findresponse.msg })
                    }
                })
        }
            else {
                this.ListER();
            }
        }
        else if (targetLaneId == 'progresslane' && sourceLaneId != targetLaneId) { // When dragged to Progress Lane
            if (status == 50) { // When status is Assigned, Open modal
                this.setState({ kanban_status: 1 });
                document.getElementById("dragEndStatusModal").click();
            }
            else if (status == 85 || status == 82 || status == 88 || status == 83 || status == 84 || status == 80 || status == 90) { // When status is Tested, QAReady, ProdReady, PMReview, PMPassed, Resloved, Closed, Change to Re-open
            const fd = new FormData;
                fd.append('status', 60); // Change to Re-Open
                fetch(this.state.apiUrl + '/ErRest/ChangeStatusFromKanban/id/' + card + '/userAuthKey/' + this.state.userAuthKey + '/userId/' + this.state.userId, {
                method: 'POST',
                dataType: 'json',
                body: fd,
            })
                .then((Response) => Response.json())
                .then((findresponse) => {
                    findresponse = this.rawjsonparse(findresponse, 1);
                    if (findresponse.code == 200) {
                        this.setState({ message: findresponse.msg }, function () {
                            this.ListER();
                        });
                    } else {
                        this.setState({ message: findresponse.msg })
                    }
                })
        }
            else { this.ListER(); }
                }
        else if (targetLaneId == 'testlane' && sourceLaneId != targetLaneId) { // When dragged to Test Lane
            if (status == 55 || status == 60) { // When Status is Active, Re-open, OPen modal
                    this.setState({ kanban_status: 2 });
                document.getElementById("dragEndStatusModal").click();
                }
            else { this.ListER(); }
                }
        else if (targetLaneId == 'closedlane' && sourceLaneId != targetLaneId) { // When dragged to Closed Lane
            if (status == 50 || status == 55 || status == 80 || status == 82 || status == 83 || status == 60 || status == 84 || status == 85 || status == 88) { // Change to close
            const fd = new FormData;
                fd.append('status', 90); // Change to Closed
                fetch(this.state.apiUrl + '/ErRest/ChangeStatusFromKanban/id/' + card + '/userAuthKey/' + this.state.userAuthKey + '/userId/' + this.state.userId, {
                method: 'POST',
                dataType: 'json',
                body: fd,
            })
                .then((Response) => Response.json())
                .then((findresponse) => {
                    findresponse = this.rawjsonparse(findresponse, 1);
                    if (findresponse.code == 200) {
                        this.setState({ message: findresponse.msg }, function () {
                            this.ListER();
                        });
                    } else {
                        this.setState({ message: findresponse.msg })
            }
                })
        }
            else { this.ListER(); }
    }
        else if (sourceLaneId == targetLaneId) {

        }
        else { this.ListER(); }
        this.setState({ errors: '' })
        this.setState({ card_id: card });
        }

    Reset() {
        var all_filters = this.getAllfilterKeys();
        for (var key in all_filters) {
            localStorage.setItem(all_filters[key], '');
            this.setState({ [all_filters[key]]: '', product_line: [] });
        }
        var obj = this;
        setTimeout(function () {
            obj.ListER();
        }, 100);
    }

    ListER() {
        $(document).ready(function () {
            $('.loader-new').removeClass('hidden');
            $('.list_check').addClass('hidden');
        });
        fetch(this.state.apiUrl + '/ErRest/ListKanban/userAuthKey/' + this.state.userAuthKey + '/userId/' + this.state.userId, {
            method: 'POST',
            dataType: 'json',
            body: JSON.stringify(this.state),
        })
            .then((Response) => Response.json())
            .then((findresponse) => {
                findresponse = this.rawjsonparse(findresponse, 1);
                $(document).ready(function () {
                    $('.loader-new').addClass('hidden');
                    $('.list_check').removeClass('hidden');
                });
                this.setState({
                    loading: 0,
                    boardData: {
                        lanes: findresponse.lanes,
                    },
                    product_line: findresponse.product_line,
                    status: findresponse.status,
                    kanban_progress_status: findresponse.kanban_progress_status,
                    kanban_test_status: findresponse.kanban_test_status,
                    item_count: findresponse.item_count,
                    owners: findresponse.owners
                })
            })
    }

    jumpSubmit(event) {
        if (event.key == 'Enter') {
            fetch(this.state.apiUrl + '/ErRest/viewEr/userAuthKey/' + this.state.userAuthKey + "/id/" + event.target.value)
                .then((Response) => Response.json())
                .then((responseJson) => {
                    responseJson = this.rawjsonparse(responseJson, 1);
                    this.props.history.push('/viewEr/' + responseJson.er.id);
                })
        }
    }

    changeStatus() {
        if (this.handleValidation()) {
        } else {
            return false;
        }
        const fd = new FormData;
        var status = document.getElementById('status_name').value;
        fd.append('status', status);
        fetch(this.state.apiUrl + '/ErRest/ChangeStatusFromKanban/id/' + this.state.card_id + '/userAuthKey/' + this.state.userAuthKey + '/userId/' + this.state.userId, {
            method: 'POST',
            dataType: 'json',
            body: fd,
        })
            .then((Response) => Response.json())
            .then((findresponse) => {
                findresponse = this.rawjsonparse(findresponse, 1);
                if (findresponse.code == 200) {
                    this.setState({ message: findresponse.msg }, function () {
                        this.ListER();
                        document.getElementById("close_modal_button").click();
                    });
                } else {
                    this.setState({ message: findresponse.msg })
                }
            })
    }

    getUserRows() {
        if (this.state.loading) {
            return (
                <div class="loader-new"></div>
            )
        }
        else {
            return (
                <div>
                    <div class="loader-new"></div>
                    <div class="list_check hidden">
                        <div class="tickets hidden-sm kanban_board">
                                <Board data={this.state.boardData} 
                                    draggable 
                                    laneDraggable={false}
                                    onCardClick={this.onCardClick}
                                    handleDragEnd={this.handleDragEnd.bind(this)} 
                                    customCardLayout>
                                    <CustomCard />
                            </Board>
                        </div>
                    </div>
                </div>
            )
        }
    }

    getAllfilterKeys() {
        var filter_keys = ["kanban_product_line_name", "search", "kanban_owner_name"];
        return filter_keys;
    }

    goToErDetails(id) {
        window.location.href = '/viewEr/' + id;
    }

    componentDidMount() {
        var obj = this;
        document.title = "Intranet | Kanban";
        if (!localStorage.getItem('userLogin')) {
            this.setState({ redirect: true });
        }
        var filter_keys = this.getAllfilterKeys();
        for (var key in localStorage) {
            if (filter_keys.includes(key)) {
                if (key == 'kanban_product_line_name') {
                    if (localStorage.getItem(key)) {
                        let x = localStorage.getItem(key);
                        this.setState({ 'kanban_product_line_name': x })
                    }
                }
                else if (key == 'kanban_owner_name') {
                    if (localStorage.getItem(key)) {
                        let x = localStorage.getItem(key);
                        this.setState({ 'kanban_owner_name': x })
                    }
                }
            }
        }
        setTimeout(function () {
            obj.ListER();
        }, 100);
        $('.searchTicket.dept').on('click', function () {
            $(this).closest('.customer').find('.filter_dept').slideToggle('slow');
        });
    }
    render() {
        if (this.state.redirect) {
            return (
                <Redirect to={'/login'} />
            )
        }
        return (
            <div>
                <Header brecum_name="ER" brecum_page="Kanban" />
                <div class="right_col">
                    {/* <!-- Modal Start --> */}
                    <div id="myModal" class="modal fade" role="dialog" data-backdrop="static" data-keyboard="false">
                        <div class="modal-dialog">
                            {/* <!-- Modal content--> */}
                            <div class="modal-content">
                                <div class="modal-header">
                                    <button type="button" class="close" data-dismiss="modal" onClick={() => this.ListER()}>&times;</button>
                                    <h4 class="modal-title">Change Status For Er : {this.state.card_id}</h4>
                                </div>
                                <div class="modal-body form-group">
                                    <label>Status</label>
                                    <div class="filter">
                                        <select class="form-control" name="status_name" id="status_name" onChange={this.onStatusChange}>
                                           {this.state.kanban_status == 2 ?<option value=''>{'All'}</option>:''}
                                            {this.state.kanban_status == 1 ?
                                                this.state.kanban_progress_status.map((dynamicData, index) =>
                                                    <option value={dynamicData.key}>{dynamicData.value}</option>
                                                )
                                                : (this.state.kanban_status == 2 ?
                                                    this.state.kanban_test_status.map((dynamicData, index) =>
                                                        <option value={dynamicData.key}>{dynamicData.value}</option>
                                                    )
                                                    : this.state.workflow.map((dynamicData, index) =>
                                                            <option value={dynamicData.key}>{dynamicData.value}</option>
                                                        )
                                                    )
                                            }
                                        </select>
                                        <i class="fa fa-angle-down" aria-hidden="true"></i>
                                        <span class="error">{this.state.errors["status_name"]}</span>
                                    </div>
                                </div>
                                <div class="modal-footer">
                                    <button type="button" class="btn btn-sky" onClick={() => this.changeStatus()}>Change Status</button>
                                    <button type="button" class="btn btn-blue" id="close_modal_button" data-dismiss="modal" onClick={() => this.ListER()}>Close</button>
                                </div>
                            </div>

                        </div>
                    </div>
                    {/* <!-- Modal End --> */}
                    <section class="customer">
                        <div id="exTab1" class="container">
                            <ul class="nav nav-pills pull-left border_less hidden-sm">
                                <ul class="nav nav-pills pull-left border_less hidden-sm">
                                    <li class="">
                                        <Link to={`/kanban/`} name={"max"} >Kanban</Link>
                                    </li>
                                </ul>
                            </ul>
                            <div class="pull-right text-color-gray hidden-sm">Recently Visited:
                                    {this.state.recentlyview ?
                                    this.state.recentlyview.map((recentid, key) =>
                                        <a href={'/viewEr/' + recentid} >&nbsp;{recentid} {this.state.recentlyview.length != (key + 1) ? '|' : ''}</a>
                                    )
                                    : ''}
                            </div>
                            <div class="tab-content er_content clearfix">
                                <div class="tab-pane active" id="Leads">
                                    <div class="top-row m_t_20">
                                        <div class="kanban_l pull-left">
                                            <a href="javascript:void(0)" id="dragEndStatusModal" class="btn btn-sky hidden" data-toggle="modal" data-target="#myModal">Open Modal</a>
                                            <div class="col-md-5 col-xs-12 padding_less">
                                                        <div class="filter">
                                                        <select value={this.state.kanban_product_line_name} class="form-control" name="kanban_product_line_name" onChange={this.onChange}>
                                                        <option value='' selected="selected">Select Pod/Department</option>
                                                            {
                                                                this.state.product_line.map((dynamicData, index) =>
                                                                    <option value={dynamicData.key}>{dynamicData.value}</option>
                                                                )
                                                            }
                                                        </select>
                                                    <i class="fal fa-angle-down"></i>
                                                    </div>
                                                </div>
                                            <div class="col-md-5 col-xs-12">
                                                <div class="filter">
                                                    <select value={this.state.kanban_owner_name} class="form-control" name="kanban_owner_name" onChange={this.onChange}>
                                                        <option value='' selected="selected">Assigned To</option>
                                                        {
                                                            this.state.owners.map((dynamicData, index) =>
                                                                <option value={dynamicData.id}>{dynamicData.name}</option>
                                                            )
                                                        }
                                                    </select>
                                                    <i class="fal fa-angle-down"></i>
                                                </div>
                                            </div>
                                            <div class="col-md-2 col-xs-12 padding_less">
                                                    <button className="btn btn-blue" onClick={() => this.Reset()}>Reset</button>
                                                </div>
                                        </div>
                                        <div class="right-section kanban_r">
                                            <div class="row er_box">
                                                <div class="col-md-12 col-xs-12">
                                                    <div class="searchTicket emp_dept">
                                                        <input type="text" value={this.state.search} class="form-control" name="search" id="search" placeholder="Search" onChange={this.searchChange} onKeyPress={this.jumpSubmit.bind(this)} />
                                                        <button type="submit"><i class="fa fa-search"></i></button>
                                                    </div>
                                                    <div class="searchTicket filter dept hidden-md"><i class="fa fa-sliders hidden-md filter"></i></div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                        {
                                        this.state.kanban_product_line_name != '' ? this.getUserRows() : <div class="welcome"><div class="in"><h4>To see the Kanban View</h4><h3>SELECT POD FIRST</h3></div></div>
                                    }
                                </div>
                            </div>
                        </div>
                    </section>
                </div>
            </div>
        );
    }
}
export default Kanban;



// WEBPACK FOOTER //
// ./src/components/er/Kanban.js